// Mock data for Nala Kitchen & Cocktails — luxury dining & nightlife venue
// NOTE: All data below is MOCKED for the frontend teaser.

export const BRAND = {
  name: "Nala Kitchen & Cocktails",
  tagline: "The Celebration Destination",
  chef: "Chef Sosa",
  phone: "(678) 906-5301",
  phoneHref: "tel:+16789065301",
  email: "info@nalakitchencocktails.com",
  address: "4183 Roswell Rd NE, Atlanta, GA 30342",
  city: "Atlanta, GA",
  rating: "4.6",
  reviewCount: "340+",
  logos: {
    gold: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/n8xus04g_Logo_Gold%2BNala%2BLogo%2B.png",
    white: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/i8ebz7q5_Logo_White%2BNala%2BLogo.png",
    full: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/e4ih7oyc_Logo_Full%2Bcolour%2BNala%2BLogo%2B.png",
    black: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/l10c96a4_Logo_Black%2BNala%2BLogo%2Bcopy.png",
  },
  social: {
    instagram: "https://www.instagram.com/nala_atl/",
    google: "https://www.google.com/maps/place/NALA+KITCHEN+%26+COCKTAILS/data=!4m2!3m1!1s0x0:0xccbdad98af017c24?sa=X&ved=1t:2428&ictx=111",
    yelp: "https://www.yelp.com/biz/nala-atlanta",
    apple: "https://maps.apple.com/place?address=4183%20Roswell%20Rd%0AAtlanta,%20GA%20%2030342%0AUnited%20States&coordinate=33.869008,-84.380681&name=NALA%20KITCHEN%20%26%20COCKTAILS&place-id=I834EC100FA5223FD&map=explore",
  },
  reservationUrl: "https://www.opentable.com/booking/restref/availability?lang=en-US&restRef=1387903&otSource=Restaurant%20website",
};

export const HOURS = [
  { day: "Monday – Tuesday", time: "Closed" },
  { day: "Wednesday – Saturday", time: "5:00 PM – 2:00 AM" },
  { day: "Sunday", time: "5:00 PM – 12:00 AM" },
];

export const IMAGES = {
  heroInterior: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  interior2: "https://images.pexels.com/photos/10633476/pexels-photo-10633476.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  interior3: "https://images.unsplash.com/photo-1679312061521-d7d619a8cfb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lounge1: "https://images.unsplash.com/photo-1679419860191-278d0720bc1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lounge2: "https://images.unsplash.com/photo-1679419857738-f8a7ca8c5de5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  night1: "https://images.unsplash.com/photo-1652517816501-a884c3ad929e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  night2: "https://images.unsplash.com/photo-1692455129272-60299bc2b1a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  night3: "https://images.unsplash.com/photo-1692455129277-90c4e69a3c7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // Authentic Nala food photography
  tomahawk: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/9gaqvhas_Tomahawk-1.jpg",
  lamb: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/awjcl8n6_Lamb-1.jpg",
  mussels: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/0a1czbsy_Mussels-2.webp",
  shrimp: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/s6idojvf_Shrimp-2.webp",
  lobster: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/fmalf4sg_Loster%2BDish-7.jpg",
  lobster2: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/l88qgql6_Loster%2BDish-2-726f7fe7.jpg",
  friedMushrooms: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/ewefwgim_Fried%2BMushrooms%2Band%2BDip-1.webp",
  brusselSalad: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/vin7n5ti_Brussel%2BSprout%2BSalad-1.webp",
  caesarSalad: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/o6htcpf2_Brussel%2BSprout%2BSalad-2.jpg",
  cocktailA3: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/ircqfe9h_a3-1920w.webp",
  // Authentic Nala signature cocktails
  ckSuperior1: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/datrlcli_The%2BSuperior-1-56a3a8e2.jpg",
  ckSuperior4: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/y5uqjvri_The%2BSuperior-4.webp",
  ckSuperior7: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/fgn78y7w_The%2BSuperior-7-2754bf05.webp",
  ckPurple: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/srigani9_Purple%2Bcocktail-1.webp",
  ckPurpleDill: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/f4vf7vg1_Purple%2Band%2BDill%2Bcocktails-1.webp",
  ckGroup: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/vwar7kvu_Cocktail%2BGroup%2BShots-4.webp",
  ckSplash: "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/chwh53dp_Island%2BEmber-4.webp",
  steak: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  saucePlate: "https://images.unsplash.com/photo-1643879397174-4f10ac503566?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  salmon: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  plated: "https://images.unsplash.com/photo-1568600891621-50f697b9a1c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktailDark: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktailPink: "https://images.unsplash.com/photo-1609951651556-5334e2706168?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktailOrange: "https://images.unsplash.com/photo-1657313666513-70770d329ef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktails3: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  champPour: "https://images.unsplash.com/photo-1580657274234-7339717f4541?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  champFlutes: "https://images.unsplash.com/photo-1613477581402-306fa9dc6b95?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICES = [
  {
    title: "Our Menu",
    desc: "Savor a refined menu featuring a fusion of bold flavors, fresh ingredients, and expertly crafted dishes designed to impress every palate.",
    cta: "View Menu",
    to: "/menu",
    image: IMAGES.lobster,
  },
  {
    title: "Nightlife & Events",
    desc: "As the sun sets, Nala transforms into a vibrant hub of entertainment — live DJs, bottle service, and exclusive VIP experiences.",
    cta: "Reserve",
    to: "/reservations",
    image: IMAGES.ckPurple,
  },
  {
    title: "Host an Event",
    desc: "Corporate gatherings, birthdays, or private parties — an upscale setting, exceptional service, and customizable packages.",
    cta: "Learn More",
    to: "/private-events",
    image: IMAGES.ckGroup,
  },
  {
    title: "VIP Guest List",
    desc: "Be the first to receive event announcements, promotions, and access to exclusive parties & special events.",
    cta: "Join List",
    to: "/reservations",
    image: IMAGES.ckSuperior1,
  },
  {
    title: "Catering To-Go",
    desc: "From intimate gatherings to large-scale functions, we craft dishes and beverages tailored to your event.",
    cta: "Learn More",
    to: "/contact",
    image: IMAGES.friedMushrooms,
  },
  {
    title: "Join Our Team",
    desc: "We're always looking for passionate individuals who thrive in a fast-paced, dynamic hospitality environment.",
    cta: "Apply",
    to: "/contact",
    image: IMAGES.brusselSalad,
  },
];

export const SIGNATURE_DISHES = [
  { name: "Lamb Lollipops", desc: "Chimichurri", price: "$40", image: IMAGES.lamb },
  { name: "Lobster", desc: "Caviar · ancho chili grits", price: "MKT", image: IMAGES.lobster },
  { name: "Tomahawk", desc: "Marbled potatoes", price: "MKT", image: IMAGES.tomahawk },
  { name: "Royal Red Shrimp Scampi", desc: "White wine · asparagus · cherry tomatoes", price: "$30", image: IMAGES.shrimp },
];

export const SIGNATURE_COCKTAILS = [
  { name: "Lion's Kiss", desc: "Woodford Reserve · peach pecan demerara · lemon · amaro · elderflower", price: "$18", image: IMAGES.ckSuperior1 },
  { name: "The Muse", desc: "Gray Whale gin · cucumber · dill · strawberry aloe liqueur · lemon", price: "$18", image: IMAGES.ckPurple },
  { name: "Nala-Rita", desc: "Patron · triple sec · peach · honey", price: "$18", image: IMAGES.ckSplash },
  { name: "Emerald's Kiss", desc: "Herradura silver · lime juice · cointreau", price: "$18", image: IMAGES.ckPurpleDill },
];

export const GALLERY = [
  { src: IMAGES.tomahawk, label: "Tomahawk" },
  { src: IMAGES.ckSuperior1, label: "The Superior" },
  { src: IMAGES.lamb, label: "Lamb Lollipops" },
  { src: IMAGES.shrimp, label: "Royal Red Shrimp" },
  { src: IMAGES.ckPurple, label: "Signature Cocktails" },
  { src: IMAGES.lobster, label: "Lobster & Caviar" },
  { src: IMAGES.mussels, label: "Mussels" },
  { src: IMAGES.ckPurpleDill, label: "Craft Cocktails" },
];

export const REVIEWS = [
  { name: "Jamaya Brown", meta: "Local Guide · 15 reviews", rating: 5, text: "My experience here was amazing! Special thanks to Sheena & Yenit — Sheena was so sweet & welcoming and checked on us all night." },
  { name: "Nick Ed", meta: "Local Guide · 153 reviews", rating: 5, text: "In the heart of Buckhead, this spot delivers elevated vibes. Perfect for celebrations. Staff went above and beyond." },
  { name: "C. Mar", meta: "Local Guide · 158 reviews", rating: 5, text: "Beautiful restaurant with amazing service. The ambiance is top tier. Food and drinks were great and staff was attentive." },
  { name: "Tia Bolden", meta: "Local Guide · 16 reviews", rating: 5, text: "Came for my birthday — AJ made the experience incredible. Amazing service, great suggestions, very accommodating." },
  { name: "Rikeisha Austin", meta: "Local Guide · 22 reviews", rating: 5, text: "Hosted a private event — upscale atmosphere, great food & drinks, and amazing staff. The vibe is unmatched." },
  { name: "Zetseat Desalegne", meta: "1 review · 2 months ago", rating: 5, text: "The peri peri wings were perfectly sweet & spicy. The mussels had a flavorful red sauce and the cheesecake was the best I've ever had. 10/10." },
];

// ---------------- FULL MENU ----------------
export const FOOD_MENU = [
  {
    category: "Bread Service",
    items: [
      { name: "Country Bread w/ Butter Service", desc: "Jalapeño butter · honey butter · herb olive oil", price: "$6" },
    ],
  },
  {
    category: "Starters",
    items: [
      { name: "Deviled Eggs", desc: "", price: "$16" },
      { name: "Southern Fried Mushrooms", desc: "", price: "$15" },
      { name: "Nala Salad", desc: "Local greens · marinated tomatoes · garden radish · aceto balsamic · olive oil", price: "$16" },
      { name: "Classic Caesar Salad", desc: "Brioche croutons · pecorino · caesar dressing", price: "$17" },
      { name: "Oyster Rockerfeller", desc: "James River oysters · sweet vermouth · panko", price: "$28" },
      { name: "Lobster Bites", desc: "Remoulade sauce", price: "$34" },
    ],
  },
  {
    category: "Chef's Selection",
    items: [
      { name: "Wild Mushroom Rice", desc: "Local forged mushrooms · basmati · pea · ginger", price: "$20" },
      { name: "Peri-Peri Wings", desc: "", price: "$18" },
      { name: "Nala Sliders", desc: "House grind · muenster cheese · pickles · Nala aioli · vegan option available", price: "$19" },
      { name: "Creamy Creole Pasta", desc: "Cajun cream · cherry tomatoes · grilled sweet peppers · parmesan · add shrimp $20 / salmon $17 / lobster $24", price: "$22" },
      { name: "Creamy Spinach Stuffed Chicken", desc: "Joyce Farm chicken · spinach · cream cheese · mashed potatoes · grilled broccolini · citrus cream", price: "$30" },
      { name: "Salmon Filet", desc: "Verde rice · lemon butter sauce", price: "$32" },
      { name: "Royal Red Shrimp Scampi", desc: "White wine · asparagus · cherry tomatoes", price: "$30" },
      { name: "Lamb Lollipops", desc: "Chimichurri", price: "$40" },
    ],
  },
  {
    category: "Specials",
    items: [
      { name: "Tomahawk", desc: "Marbled potatoes", price: "MKT" },
      { name: "Lobster", desc: "Caviar · ancho chili grits", price: "MKT" },
    ],
  },
  {
    category: "Sides",
    items: [
      { name: "Seasonal Veggies", desc: "Broccolini · asparagus", price: "$7" },
      { name: "French Fries", desc: "", price: "$7" },
      { name: "Savannah Red Rice", desc: "", price: "$7" },
      { name: "Truffle Fries", desc: "", price: "$10" },
      { name: "Mashed Potatoes", desc: "", price: "$10" },
      { name: "Crispy Brussels", desc: "", price: "$11" },
      { name: "Ancho Chili Grits", desc: "", price: "$11" },
      { name: "Mac N Cheese", desc: "", price: "$13" },
      { name: "Lobster Mac N Cheese", desc: "", price: "$23" },
    ],
  },
  {
    category: "Additional Toppings",
    items: [
      { name: "Chicken", desc: "", price: "$16" },
      { name: "Salmon", desc: "", price: "$17" },
      { name: "Shrimp", desc: "", price: "$20" },
    ],
  },
  {
    category: "Dessert",
    items: [
      { name: "Sorbets", desc: "Daily selection", price: "$10" },
      { name: "Pistachio Bomb", desc: "Pistachios · raspberry compote · vanilla gelato", price: "$12" },
      { name: "Blueberry Cheesecake", desc: "Blueberry gelee · graham cracker crust", price: "$13" },
      { name: "Bread Pudding", desc: "Bourbon anglaise", price: "$13" },
      { name: "Flourless Chocolate Cake", desc: "Milk chocolate · strawberry coulis · chantilly", price: "$14" },
    ],
  },
];

export const COCKTAIL_MENU = [
  {
    category: "Classic",
    note: "$16",
    items: [
      { name: "Old Fashioned", desc: "Bulleit · angostura bitters · orange bitters · demerara" },
      { name: "Manhattan", desc: "Redemption Rye · angostura bitters · sweet vermouth" },
      { name: "Daiquiri", desc: "Bacardi · simple syrup · lime" },
      { name: "French 75", desc: "Ford's Gin · simple syrup · lemon · Brut champagne" },
      { name: "Side Car", desc: "Hennessy · demerara · triple sec · lemon" },
      { name: "Espresso Martini", desc: "Grey Goose · espresso · Mr Black coffee liqueur · demerara" },
      { name: "Margarita", desc: "El Jimador · triple sec · agave · lime" },
    ],
  },
  {
    category: "Signature",
    note: "$18",
    items: [
      { name: "Lion's Kiss", desc: "Woodford Reserve · peach pecan demerara · lemon · amaro · angostura · elderflower liqueur" },
      { name: "Emerald's Kiss", desc: "Herradura silver · lime juice · cointreau" },
      { name: "The Muse", desc: "Gray Whale gin · cucumber · dill · strawberry aloe liqueur · demerara · lemon" },
      { name: "Safari Whisper", desc: "Ketel One · elderflower liqueur · lemon · honey · rosemary" },
      { name: "Ginger Blossom", desc: "D'ussé · Stirrings ginger liqueur · strawberry · lemon" },
      { name: "Nala-Rita", desc: "Patron · triple sec · peach · honey" },
    ],
  },
  {
    category: "Beer",
    note: "$6",
    items: [
      { name: "Stella", desc: "" }, { name: "Blue Moon", desc: "" }, { name: "Guinness", desc: "" }, { name: "Bud Light", desc: "" },
      { name: "Corona", desc: "" }, { name: "Modelo", desc: "" }, { name: "Heineken", desc: "" }, { name: "Modelo Negra", desc: "" },
    ],
  },
  {
    category: "Non-Alcoholic",
    items: [
      { name: "Erian Still Water", desc: "", price: "$5/9" },
      { name: "Erian Sparkling Water", desc: "", price: "$5/9" },
      { name: "Soft Drinks", desc: "", price: "$5" },
      { name: "Red Bull", desc: "", price: "$5" },
      { name: "Ginger Beer", desc: "", price: "$5" },
    ],
  },
  {
    category: "By The Barista",
    items: [
      { name: "Coffee", desc: "", price: "$3" },
      { name: "Espresso", desc: "", price: "$4" },
      { name: "Hot Tea", desc: "Earl Grey · mint · chamomile", price: "$4" },
      { name: "Cappuccino", desc: "", price: "$5" },
      { name: "Macchiato", desc: "", price: "$5" },
    ],
  },
];

export const BOTTLE_MENU = [
  { category: "Sparkling", items: [
    { name: "Avissi, Prosecco, Veneto, IT.", price: "$13/$40" },
    { name: "Chic Barcelona, Cava Brut, SP.", price: "$13/$40" },
    { name: "Lucien Albrecht, Cremant Brut, Alsace, FR.", price: "$15/$45" },
  ]},
  { category: "White Wine", items: [
    { name: "Firestone Vineyard, Riesling, CA, US.", price: "$13/$40" },
    { name: "Barone Fini, Pinot Grigio, Trentino, IT. '18", price: "$14/$45" },
    { name: "Ferrari-Carano, Sauv. Blanc, CA, US '19", price: "$13/$40" },
    { name: "Liquid Light, Chardonnay, WA, US.", price: "$18/$54" },
    { name: "Illumination, Sauv Blanc, CA, US '23", price: "$100" },
    { name: "Flowers Chardonnay, CA, US '23", price: "$80" },
  ]},
  { category: "Red Wine", items: [
    { name: "Diora Wines, Pinot Noir, CA, US '17", price: "$15/$45" },
    { name: "Belle Glos Pinot Noir, CA, US '23", price: "$20/$60" },
    { name: "Skyfall Vineyard, Merlot, WA, US '16", price: "$17/$52" },
    { name: "Château Ste. Cab Sauv, WA, US '20", price: "$14/$45" },
    { name: "Torbreck, Woodcutter's Shiraz, AU '21", price: "$18/$54" },
    { name: "Intrinsic, Red Blend, WA, US '21", price: "$13/$40" },
    { name: "Antigal Winery, Malbec, Mendoza, ARG '13", price: "$17/$52" },
    { name: "Prisoner Red Blend, CA, US.", price: "$80" },
    { name: "Faust, Cabernet Sauv, CA, US '22", price: "$120" },
    { name: "Caymus Vineyards, Cabernet Sauv, CA, US '21", price: "$180" },
  ]},
  { category: "Champagne by the Bottle", items: [
    { name: "Ace of Spades", price: "$500" },
    { name: "Dom Pérignon", price: "$400" },
    { name: "Moët Ice", price: "$200" },
    { name: "Moët Rosé", price: "$250" },
    { name: "Veuve Clicquot", price: "$200" },
    { name: "French Cancan, Brut Rosé, FR.", price: "$80" },
  ]},
  { category: "Tequila", items: [
    { name: "Clase Azul", price: "$40/$500" },
    { name: "Don Julio 1942", price: "$40/$500" },
    { name: "Casamigos Añejo", price: "$15/$325" },
    { name: "Don Julio Blanco", price: "$14/$250" },
    { name: "Patron Silver", price: "$13/$225" },
    { name: "Herradura Añejo", price: "$16/$350" },
  ]},
  { category: "Cognac", items: [
    { name: "D'ussé", price: "$16/$300" },
    { name: "Hennessy", price: "$13/$250" },
    { name: "Rémy 1738", price: "$15/$300" },
    { name: "Rémy VSOP", price: "$13/$250" },
  ]},
  { category: "Whiskey / Bourbon", items: [
    { name: "Bulleit Bourbon", price: "$12/$200" },
    { name: "Crown Royal", price: "$12/$225" },
    { name: "Jack Daniel's", price: "$12/$225" },
    { name: "Woodford Reserve", price: "$15/$300" },
    { name: "Glenlivet 18", price: "$18/$350" },
  ]},
  { category: "Vodka & Gin", items: [
    { name: "Grey Goose", price: "$14/$250" },
    { name: "Ketel One", price: "$13/$225" },
    { name: "Tito's Handmade", price: "$12/$200" },
    { name: "Hendrick's", price: "$16/$250" },
    { name: "Tanqueray", price: "$15/$225" },
  ]},
];

export const MENU_PDF = "https://customer-assets.emergentagent.com/job_nala-premium-venue/artifacts/n0x7vf12_NalaFoodMENU_8p5x11_July8.pdf";

export const HAPPY_HOUR = {
  days: "Wednesday & Thursday",
  time: "5PM – 8PM",
  halfOff: [
    "Salads", "Wings", "Sliders", "Brussels",
    "Crispy Oyster Mushrooms", "Fries", "Mac N Cheese",
  ],
  glasses: [
    { name: "House Red Glass", price: "$7" },
    { name: "House White Glass", price: "$7" },
    { name: "Prosecco Glass", price: "$7" },
    { name: "Rosé", price: "$7" },
    { name: "Glass Hookah", price: "$25" },
    { name: "Hookah Refill", price: "$10" },
  ],
  shots: [
    { name: "Whisky Shot / Cocktail", price: "$6 / $7" },
    { name: "Vodka Shot / Cocktail", price: "$6 / $7" },
    { name: "Tequila Shot / Cocktail", price: "$6 / $7" },
  ],
};

export const HOOKAH_MENU = {
  price: "$25",
  refill: "$15",
  flavors: ["Angel Lips", "Blue Mist", "Blueberry Yum Yum", "Double Apple", "Gum Mint", "Lady Killer", "Love 66", "Mighty Freeze"],
};

export const BOTTLE_PACKAGES = [
  { name: "The Red Room", tier: "Premium VIP", desc: "Our most exclusive table experience with dedicated host, prime seating and priority entry.", perks: ["Prime VIP seating", "Dedicated bottle host", "Priority entry", "2 premium bottles included"], price: "From $650" },
  { name: "Nightlife Table", tier: "Bottle Service", desc: "Reserve a table for the night with premium bottle service and mixers of your choice.", perks: ["Reserved table", "1 premium bottle", "Mixers & garnishes", "Sparkler presentation"], price: "From $350" },
  { name: "Celebration Package", tier: "Birthdays & Groups", desc: "Perfect for birthdays and group celebrations with champagne and dessert presentation.", perks: ["Group seating", "Champagne toast", "Dessert presentation", "Photo moment"], price: "From $450" },
];
